module.exports = __webpack_public_path__ + "media/new-pdf-report-layout/dane-b30ac3f3.svg";